var map = {
	"./aeilo-1.jpg": "fa42",
	"./aeilo.jpg": "8839",
	"./aponix-1.jpg": "6fa3",
	"./aponix.jpg": "7db7",
	"./background.jpg": "1f54",
	"./blake-1.jpg": "7b7e",
	"./blake.jpg": "a523",
	"./dart-1.jpg": "38dd",
	"./dart.jpg": "284c",
	"./doha-1.jpg": "8a98",
	"./doha.jpg": "0b6b",
	"./swell-1.jpg": "6a45",
	"./swell.jpg": "2f33",
	"./tricky-1.jpg": "240f",
	"./tricky.jpg": "4008",
	"./vanax-1.jpg": "f0d4",
	"./vanax.jpg": "b8cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8072";